import React from 'react';
import { Navigate } from 'react-router-dom';

export default function Terms() {
  return <Navigate to="/about#terms" replace />;
}
